import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BookingModel, BookingService, invoice} from 'src/app/Api_Module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-checkout-booking-modal',
  templateUrl: './checkout-booking-modal.component.html',
})
export class CheckOutBookingModalComponent implements OnInit {
  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Input() booking: BookingModel;
  @Output() success: EventEmitter<any> = new EventEmitter();
  invoice: invoice = {} as invoice;
  loading: boolean;
  messages = {emptyMessage: 'No invoice items', totalMessage: 'Total Items'};

  constructor(private modalService: NgbModal, private bookingService: BookingService,
     private route: ActivatedRoute, private toastr: ToastrService) {
  }

  ngOnInit() {
  }

  openLg(content) {
    if (this.booking.isMonthlyParker !== true) {
      this.modalService.open(content, { size: 'lg' });
    }
    this.loading = true;
    this.bookingService.checkout(this.booking.bookingId).subscribe((resp: invoice) => {
      this.loading = false;
      this.invoice = resp;
      if (this.booking.isMonthlyParker) {
        this.booking.paymentType = "Monthly";
        this.checkout();
      }
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        console.log('error:' + JSON.stringify(error));
      });
  }

  close(alert: any) {
    // this.alert = null;
  }

  checkout() {
    console.log('checkout data' + JSON.stringify(this.booking));
    this.loading = true;
    this.bookingService.complete({ id: this.booking.bookingId, paymentMethod: this.booking.paymentType}).subscribe(resp => {
      this.loading = false;
      this.toastr.success('Checkout Complete');
      this.success.emit('Checkout Complete');
      this.modalService.dismissAll();
    },
      error => {
        this.loading = false;
        this.toastr.error('Something went wrong please try again later!');
        console.log('error:' + JSON.stringify(error));
      });
  }
}
